import { render } from "./keyIcon.svg?vue&type=template&id=7298f0cc"
const script = {}
script.render = render

export default script